<template>
    <v-container>
        <div v-if="!isBusy && !isAdmin"> You dont have permission to view this page</div>
        <div v-if="isAdmin">
            <div class="d-flex justify-space-between mt-10 mb-5">
                <h2 class="mb-3">Report Builder</h2>
            </div>

            <v-select :items="reports"
                      item-text="name"
                      return-object
                      v-model="selectedReport"
                      label="Select Report"></v-select>

        </div>

        <v-container fill-height v-show="selectedReport">

            <v-row>
                <v-col cols="12" class="text-right">
                    <v-switch v-model="isEditMode"
                              label="Edit Mode"></v-switch>
                </v-col>
            </v-row>
            <v-btn class="mr-2 mt-1 mb-6"
                   v-show="isEditMode"
                   @click="onAddRow(-1, 12)"
                   color="default">
                <v-icon class="mr-1">mdi-plus</v-icon> Add Row
            </v-btn>
            <div class="report-builder-container">
                <v-row v-for="(row, rowIndex) in reportLayouts" :key="row.id">

                    <v-text-field cols="12" hint="Update Row Title"
                                  label="Row Title (Optional)"
                                  @input="onTitleChange(rowIndex + 1)"
                                  v-show="isEditMode"
                                  v-model="row.cols[0].title"></v-text-field>

                    <v-col cols="12" v-for="(chart, colIndex) in row.cols" :key="chart.id" :md="chart.colSpan" xs="12" sm="12">

                        <chart-view :chart-id="chart.chartId"
                                    :chart-type="chart.chartType"
                                    :report-layout-id="chart.reportLayoutId"
                                    is-report-builder
                                    @replaced="onReplaced"></chart-view>

                        <v-text-field hint="Update col span"
                                      label="Col Span"
                                      v-show="isEditMode"
                                      type="number"
                                      @input="onColSpanChange(chart)"
                                      v-model="chart.colSpan"></v-text-field>

                        <v-btn class="mr-2 mt-1"
                               color="default"
                               block
                               v-show="isEditMode"
                               @click="onAddColumn(rowIndex, colIndex)">
                            <v-icon class="mr-1">mdi-plus</v-icon> Add Column Right
                        </v-btn>
                        <v-btn class="mr-2 mt-1"
                               block
                               v-show="isEditMode && row.cols.length > 1"
                               color="default"
                               @click="onRemoveColumn(chart.reportLayoutId)">
                            Delete Column
                        </v-btn>



                    </v-col>
                    <v-btn class="mr-2 mt-5"
                           v-show="isEditMode"
                           block
                           @click="onAddRow(rowIndex)"
                           color="default">
                        <v-icon class="mr-1">mdi-plus</v-icon> Add Row Below
                    </v-btn>
                    <v-btn class="mr-2 mt-1 mb-5"
                           v-show="isEditMode"
                           block
                           @click="onRemoveRow(row.id)"
                           color="default">
                        <v-icon class="mr-1">mdi-minus</v-icon>  Delete Row
                    </v-btn>

                </v-row>

            </div>
        </v-container>

    </v-container>
</template>

<script>
    import ReportService from "../../services/reportService"
    import ReportLayoutService from "../../services/reportLayoutService"
    import config from '../../../public/okta.config.json';
    import ChartView from "../../components/charts/ChartView"
    export default {
        name: 'ReportBuilder',
        data: function () {
            return {
                isAdmin: false,
                isBusy: true,
                accessToken: "",
                reports: [],
                selectedReport: null,
                reportLayouts: [],
                isEditMode: false
            }
        },
        components: {
            ChartView
        },
        watch: {
            deep: true,
            immediate: true,
            selectedReport() {
                this.getReportLayout();
            }

        },
        computed: {

        },
        methods: {
            async setup() {
                this.accessToken = this.$auth.getAccessToken();

                var user = await this.$auth.getUser();
                this.isAdmin = user.groups.includes(config.adminGroup);

                if (this.isAdmin) {
                    await this.getReports();
                }
            },
            async getReports() {
                this.isBusy = true;
                this.reports = await ReportService.getReports(this.accessToken);
                this.isBusy = false;
            },
            getCols(cols) {
                return Math.floor(12 / cols);
            },
            onReplaced() {
                this.reportLayouts = [];
                this.getReportLayout();
            },
            async onAddColumn(rowIndex, columnIndex) {
                await ReportLayoutService.addReportLayoutColumn(
                    {
                        reportId: this.selectedReport.id,
                        rowIndex: rowIndex + 1,
                        columnIndex: columnIndex + 2,
                    }, this.accessToken);

                await this.getReportLayout();
            },
            async onAddRow(rowIndex) {
                await ReportLayoutService.addReportLayoutRow(
                    {
                        reportId: this.selectedReport.id,
                        rowIndex: rowIndex + 2
                    }, this.accessToken);

                await this.getReportLayout();
            },
            async onRemoveColumn(reportLayoutId) {

                await ReportLayoutService.removeReportLayoutColumn(
                    {
                        reportId: this.selectedReport.id,
                        reportLayoutId: reportLayoutId
                    }, this.accessToken);

                await this.getReportLayout();
            },
            async onRemoveRow(reportLayoutId) {

                await ReportLayoutService.removeReportLayoutRow(
                    {
                        reportId: this.selectedReport.id,
                        reportLayoutId: reportLayoutId
                    }, this.accessToken);

                await this.getReportLayout();
            },
            async getReportLayout() {
                if (this.selectedReport) {
                    this.reportLayouts = [];
                    this.isBusy = true;
                    let results = await ReportLayoutService.getReportLayoutsByName(this.selectedReport.name, true, this.accessToken);

                    let reportRows = [];

                    results.forEach(function (item) {

                        if (!reportRows[item.row - 1]) {
                            reportRows.push({
                                id: item.id,
                                row: item.row,
                                cols: [
                                    {
                                        chartId: item.chartId,
                                        chartType: item.chartType,
                                        reportLayoutId: item.id,
                                        colSpan: item.colSpan,
                                        title: item.title,
                                        column: item.column
                                    }
                                ]
                            });
                        }
                        else {
                            reportRows[item.row - 1].cols.push({
                                chartId: item.chartId,
                                chartType: item.chartType,
                                reportLayoutId: item.id,
                                colSpan: item.colSpan,
                                title: item.title,
                                column: item.column
                            });
                        }

                    });

                    this.reportLayouts = reportRows;
                    this.isBusy = false;
                }
            },
            async onColSpanChange(chart) {

                let request = {
                    colSpan: chart.colSpan === "" ? 0 : parseInt(chart.colSpan)
                }

                await ReportLayoutService.updateReportLayoutColSpan(chart.reportLayoutId, request, this.accessToken);
            },
            async onTitleChange(row) {

                let reportLayoutRows = this.reportLayouts.find(rp => rp.row === row);

                if (reportLayoutRows) {

                    let reportLayout = reportLayoutRows.cols.find(col => col.column === 1);

                    if (reportLayout) {

                        let request = {
                            title: reportLayout.title
                        }

                        await ReportLayoutService.updateReportLayoutTitle(reportLayout.reportLayoutId, request, this.accessToken);
                    }
                }
            }
        },
        created() {
            this.setup();
        },
        mounted() {

        },

    }
</script>
